export const isLegacyReferralFee = (record) =>
  !record?.paymentType && !record?.xeroTransactionId && !record?.stripeChargeId;

export const getReferralFeeSignedAmount = (record) => {
  const amount = Number(record?.amount) || 0;
  return isLegacyReferralFee(record) ? -Math.abs(amount) : amount;
};
